<ion-header>
  <ion-toolbar [color]="computedToolbarColor">
    @if (defaultHref) {
      <ion-buttons slot="start">
        <crowdctrl-back-button
          [defaultHref]="defaultHref"
          [backButtonIcon]="backButtonIcon"
        ></crowdctrl-back-button>
      </ion-buttons>
    }
    <ion-title>{{ pageTitle }}</ion-title>
    <ion-buttons slot="end">
      <ng-content select="[toolbarButtons],[toolbarbuttons]"></ng-content>
      @if (showRefresh) {
        <ion-button
          (click)="onRefresh()"
          fill="clear"
          [disabled]="isLoading || isLoadInFlight || isRefreshCoolingDown"
        >
          <ion-icon name="refresh" slot="icon-only"></ion-icon>
        </ion-button>
      }
      <crowdctrl-user-profile-button></crowdctrl-user-profile-button>
    </ion-buttons>
    @if (isLoading || isLoadInFlight || isAutoLoadStalling) {
      <ion-progress-bar
        type="indeterminate"
        [color]="computedProgressBarColor"
      ></ion-progress-bar>
    }
  </ion-toolbar>
  @if (showPinnedContent && pinnedContent) {
    <ion-toolbar [color]="computedToolbarColor" class="pinned-toolbar">
      <ng-container
        *ngTemplateOutlet="pinnedContent; context: pinnedContentContext"
      ></ng-container>
    </ion-toolbar>
  }
  <ng-content select="[headerContent]"></ng-content>
</ion-header>

<ion-content [class]="contentHostClasses" [scrollY]="contentScrollY">
  @if (showRefresh && contentScrollY) {
    <ion-refresher
      slot="fixed"
      [disabled]="isLoading || isLoadInFlight || isRefreshCoolingDown"
      (ionRefresh)="onIonRefresh($event)"
    >
      <ion-refresher-content></ion-refresher-content>
    </ion-refresher>
  }
  <div class="tab-page-slot" [class.tab-page-slot--fill]="!contentScrollY">
    <ng-content></ng-content>
  </div>
</ion-content>
<!-- ion-footer: direct child of host (ion-page) after ion-content. -->
<ng-content select="ion-footer"></ng-content>
<!-- FAB must be a sibling of ion-content so slot="fixed" stays viewport-fixed while content scrolls -->
<ng-content select="ion-fab"></ng-content>
